import { AppTours, DashboardIntroCard, DashboardLink, DashboardWrapper, tourSteps } from '@modules/app';
import { Col, Row } from 'antd';
import { themeConfig } from '@theme/index';
import { useMst } from '@models/Root';
import { RouteType } from '@models/Route';

interface RouteExistArgs {
  userRoutes: RouteType[];
  path: string;
}

const routeExist = ({ userRoutes, path }: RouteExistArgs): boolean => {
  return Boolean(userRoutes.find((route) => route.path === path));
};

export const StaffDashboard = () => {
  const { user } = useMst();

  return (
    <DashboardWrapper>
      <AppTours steps={tourSteps.staff} />

      <DashboardIntroCard className="intro-card" />

      <div className="dashboard-inner" id="dashboard-quick-links">
        <Row gutter={themeConfig.grid.formInputRowGutter}>
          {routeExist({ userRoutes: user.routes, path: 'students' }) && (
            <Col sm={12} md={8}>
              <DashboardLink iconName="supervised_user_circle" linkText="Students" link="/students" />
            </Col>
          )}

          {routeExist({ userRoutes: user.routes, path: 'students/registrations' }) && (
            <Col sm={12} md={8}>
              <DashboardLink iconName="library_books" linkText="Registrations" link="/students/registrations" />
            </Col>
          )}

          {routeExist({ userRoutes: user.routes, path: 'result-sheets' }) && (
            <Col sm={12} md={8}>
              <DashboardLink iconName="library_books" linkText="Results" link="/result-sheets" />
            </Col>
          )}

          {routeExist({ userRoutes: user.routes, path: 'timetable' }) && (
            <Col sm={12} md={8}>
              <DashboardLink iconName="calendar_today" linkText="Timetable" link="/timetable" />
            </Col>
          )}

          {routeExist({ userRoutes: user.routes, path: 'courses' }) && (
            <Col sm={12} md={8}>
              <DashboardLink iconName="menu_book" linkText="Courses" link="/courses" />
            </Col>
          )}

          {routeExist({ userRoutes: user.routes, path: 'batches' }) && (
            <Col sm={12} md={8}>
              <DashboardLink iconName="group" linkText="Batches" link="/batches" />
            </Col>
          )}
        </Row>
      </div>
    </DashboardWrapper>
  );
};
